module.exports = __webpack_public_path__ + "img/morocco.a1a636bf.jpg";